import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
  link: {
    textDecoration: 'none',
    '&:hover, &:focus': {
      backgroundColor: theme.palette.background.default,
      '& > .MuiSvgIcon-root': {
        display: 'inline-block',
      },
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'transparent',
    },
  },
  externalLink: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none'
  },
  linkActive: {
    backgroundColor: theme.palette.background.default,
  },
  linkNested: {
    paddingLeft: 45,
    '&:hover, &:focus': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.background.light
          : '#FFFFFF',
    },
  },
  linkIcon: {
    marginRight: theme.spacing(1),
    color: '#424242 !important',
    transition: theme.transitions.create('color'),
    display: 'flex !important',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '40px !important',
    '& svg': {
      display: 'block !important',
      fontSize: '24px !important',
      visibility: 'visible !important',
      opacity: '1 !important'
    }
  },
  linkIconActive: {
    color: `${theme.palette.primary.main} !important`,
  },
  linkText: {
    padding: 0,
    color: '#000000 !important',
    transition: theme.transitions.create(['opacity', 'color']),
    fontSize: 14,
    fontWeight: 500,
  },
  linkTextActive: {
    color: '#000000 !important',
  },
  linkTextHidden: {
    opacity: 0,
  },
  nestedList: {
    paddingLeft: 15,
  },
  sectionTitle: {
    marginLeft: theme.spacing(4.5),
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    height: 1,
    backgroundColor:
      theme.palette.type === 'dark' ? 'rgba(151,151,151, .15)' : '#D8D8D880',
  },
  expand: {
    transform: 'rotate(180deg)',
  },
  expandWrapper: {
    color: '#424242 !important',
    transition: theme.transitions.create('transform'),
    display: (props) => (props ? 'inline-flex' : 'none'),
    marginLeft: 'auto',
  },
  nestedMenu: {
    paddingLeft: 15,
  },
  nestedMenuItem: {
    paddingLeft: 20,
  },
}));
